// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1GgPX","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__12K2R"};